import Chart from "chart.js/dist/Chart"
import { mapGetters } from "vuex"
function dataHandler(newData, oldData) {
    if (oldData) {
        let chart = this.$data._chart

        // Get new and old DataSet Labels
        let newDatasetLabels = newData.datasets.map(dataset => {
            return dataset.label
        })

        let oldDatasetLabels = oldData.datasets.map(dataset => {
            return dataset.label
        })

        // Stringify 'em for easier compare
        const oldLabels = JSON.stringify(oldDatasetLabels)
        const newLabels = JSON.stringify(newDatasetLabels)

        // Check if Labels are equal and if dataset length is equal
        if (newLabels === oldLabels && oldData.datasets.length === newData.datasets.length) {
            newData.datasets.forEach((dataset, i) => {
                // Get new and old dataset keys
                const oldDatasetKeys = Object.keys(oldData.datasets[i])
                const newDatasetKeys = Object.keys(dataset)

                // Get keys that aren't present in the new data
                const deletionKeys = oldDatasetKeys.filter(key => {
                    return key !== "_meta" && newDatasetKeys.indexOf(key) === -1
                })

                // Remove outdated key-value pairs
                deletionKeys.forEach(deletionKey => {
                    delete chart.data.datasets[i][deletionKey]
                })

                // Update attributes individually to avoid re-rendering the entire chart
                for (const attribute in dataset) {
                    if (dataset.hasOwnProperty(attribute)) {
                        chart.data.datasets[i][attribute] = dataset[attribute]
                    }
                }
            })

            if (newData.hasOwnProperty("labels")) {
                chart.data.labels = newData.labels
                this.$emit("labels:update")
            }
            if (newData.hasOwnProperty("xLabels")) {
                chart.data.xLabels = newData.xLabels
                this.$emit("xlabels:update")
            }
            if (newData.hasOwnProperty("yLabels")) {
                chart.data.yLabels = newData.yLabels
                this.$emit("ylabels:update")
            }
            chart.update()
            this.$emit("chart:update")
        } else {
            if (chart) {
                chart.destroy()
                this.$emit("chart:destroy")
            }
            this.renderChart(this.chartData, this.options)
            this.$emit("chart:render")
        }
    } else {
        if (this.$data._chart) {
            this.$data._chart.destroy()
            this.$emit("chart:destroy")
        }
        this.renderChart(this.chartData, this.options)
        this.$emit("chart:render")
    }
}

export const reactiveData = {
    data() {
        return {
            chartData: null
        }
    },

    watch: {
        chartData: dataHandler
    }
}

export const reactiveProp = {
    props: {
        chartData: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
    watch: {
        chartData: dataHandler
    }
}

export const mixins = {
    reactiveData,
    reactiveProp
}

export function generateChart(chartId, chartType) {
    return {
        render: function(createElement) {
            return createElement(
                "div",
                {
                    style: this.styles,
                    class: this.cssClasses
                },
                [
                    createElement("canvas", {
                        attrs: {
                            id: this.chartId,
                            width: this.width,
                            height: this.height
                        },
                        ref: "canvas"
                    })
                ]
            )
        },

        props: {
            chartId: {
                default: chartId,
                type: String
            },
            width: {
                default: 400,
                type: Number
            },
            height: {
                default: 400,
                type: Number
            },
            cssClasses: {
                type: String,
                default: ""
            },
            styles: {
                type: Object
            },
            plugins: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        computed: {
            ...mapGetters({ darkMode: "user/darkMode" })
        },
        data() {
            return {
                _chart: null,
                _plugins: this.plugins
            }
        },

        methods: {
            addPlugin(plugin) {
                this.$data._plugins.push(plugin)
            },
            generateLegend() {
                if (this.$data._chart) {
                    return this.$data._chart.generateLegend()
                }
            },
            renderChart(data, options, plugins) {
                if (this.$data._chart) this.$data._chart.destroy()

                this.$data._chart = new Chart(this.$refs.canvas.getContext("2d"), {
                    type: chartType,
                    data: data,
                    
                    options: options,
                    plugins: this.$data._plugins
                })
                Chart.defaults.global.defaultFontColor = this.darkMode ? "#fff" : "#666"
            }
        },
        beforeDestroy() {
            if (this.$data._chart) {
                this.$data._chart.destroy()
            }
        }
    }
}

export const Bar = generateChart("bar-chart", "bar")
export const HorizontalBar = generateChart("horizontalbar-chart", "horizontalBar")
export const Doughnut = generateChart("doughnut-chart", "doughnut")
export const Line = generateChart("line-chart", "line")
export const Pie = generateChart("pie-chart", "pie")
export const PolarArea = generateChart("polar-chart", "polarArea")
export const Radar = generateChart("radar-chart", "radar")
export const Bubble = generateChart("bubble-chart", "bubble")
export const Scatter = generateChart("scatter-chart", "scatter")

export default {
    Bar,
    HorizontalBar,
    Doughnut,
    Line,
    Pie,
    PolarArea,
    Radar,
    Bubble,
    Scatter,
    mixins: {
        reactiveData,
        reactiveProp
    }
}
